import StatCard from '../../../../Components/StatCard/StatCard';
import { useSelector } from 'react-redux';

function SalesStats() {
    const salesInsights = useSelector((state) => state.reportAnalysis.salesInsights.salesInsights);

    return (
        <div className="grid grid-cols-4 gap-x-3 mx-5 mt-4">
            {
                Object.keys(salesInsights).length > 0 && 
                <>
                    <StatCard 
                        statName="Total Sales"
                        statValue={salesInsights.stats.totalSales}
                        hasPrice={true}
                        // statTrend={12}
                    />
                    <StatCard 
                        statName="Average Order Value"
                        statValue={salesInsights.stats.avgOrderValue || 0}
                        hasPrice={true}
                        // statTrend={12}
                    />
                    <StatCard 
                        statName="Total Orders"
                        statValue={salesInsights.stats.totalOrders}
                        hasPrice={false}
                        // statTrend={-24}
                    />
                    <StatCard 
                        statName="Return Rate"
                        statValue={0}
                        hasPrice={false}
                        hasPercent={true} 
                        // statTrend={-24}
                    />
                </>
            }
        </div>
    );
}

export default SalesStats;
